export default __webpack_public_path__ + "static/cashflow_new_12-aa2a496425a322a9ed8f41b4701caa56.jpg";